/**
 * NotFound.js — F08.
 *
 * The wildcard route used to render the dashboard for any unknown path, so a
 * mistyped or dead link looked like a working page showing the wrong thing.
 * A missing page now says it is missing, shows what was asked for, and offers
 * a way back. Browser Back still works — this is an ordinary route.
 *
 * Intentional legacy aliases (/support, /publish) stay as explicit redirects
 * in App.js and never reach here.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PageHead, StatePanel } from '../components/ui';
import Icon from '../components/Icon';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="page">
      <PageHead title="Page not found" />
      <StatePanel
        kind="error"
        icon="alert"
        title="We couldn't find that page"
        action={
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link className="btn btn-primary" to="/dashboard">
              <Icon name="publish" /> Go to your documents
            </Link>
            <Link className="btn btn-secondary" to="/flow">
              Go to Flow
            </Link>
          </div>
        }
      >
        <p>
          Nothing is published at <code>{location.pathname}</code>. The link may be
          out of date, or the page may have been renamed.
        </p>
        <p className="meta" style={{ marginTop: 8 }}>
          Your documents live under <strong>Publish</strong> in the sidebar.
        </p>
      </StatePanel>
    </div>
  );
}
